import { render, staticRenderFns } from "./ShowCredentialTef.vue?vue&type=template&id=61a45a12&scoped=true"
import script from "./ShowCredentialTef.vue?vue&type=script&lang=js"
export * from "./ShowCredentialTef.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a45a12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61a45a12')) {
      api.createRecord('61a45a12', component.options)
    } else {
      api.reload('61a45a12', component.options)
    }
    module.hot.accept("./ShowCredentialTef.vue?vue&type=template&id=61a45a12&scoped=true", function () {
      api.rerender('61a45a12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/tef/components/ShowCredentialTef.vue"
export default component.exports